import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import Button from '../../../elements/Button';
import { CheckBoxCell } from '../../../elements/CheckBoxCell';
import ReactTable from '../../../elements/ReactTable/ReactTable';
import FormikInput from '../../../elements/formik/FormikInput';
const style = {
    width: '100%',
    fontSize: '1.1em',
    textAlign: 'left',
    padding: '0.1em 0.1em',
};
const inputStyle = {
    border: 'none',
};
export function SpectraColumnsManager({ nucleus, onAdd, onDelete, datalist, mapOnChangeValue, mapValue, }) {
    const { values: nucleiPreferences } = useFormikContext();
    const COLUMNS = useMemo(() => [
        {
            Header: '#',
            style: { width: '25px' },
            accessor: (_, index) => index + 1,
        },
        {
            Header: 'Label',
            Cell: ({ row }) => {
                return (_jsx(FormikInput, { name: `nuclei.${nucleus}.columns.${row.index}.label`, style: { input: { ...style, ...inputStyle } } }));
            },
        },
        {
            Header: 'Column',
            Cell: ({ row }) => {
                const column = row.original;
                if (column?.name) {
                    return (_jsx("span", { style: style, children: column?.jpath?.join('.') || column.description }));
                }
                return (_jsx(FormikInput, { name: `nuclei.${nucleus}.columns.${row.index}.jpath`, style: { input: { ...style, ...inputStyle } }, datalist: datalist, mapOnChangeValue: mapOnChangeValue, mapValue: mapValue }));
            },
        },
        {
            Header: 'Visible',
            style: { width: '30px' },
            Cell: ({ row }) => (_jsx(CheckBoxCell, { name: `nuclei.${nucleus}.columns.${row.index}.visible`, defaultValue: true })),
        },
        {
            Header: '',
            style: { width: '30px' },
            id: 'add-button',
            Cell: ({ row }) => {
                const record = row.original;
                return (_jsxs("div", { style: { display: 'flex' }, children: [_jsx(Button.Done, { fill: "outline", onClick: () => onAdd(nucleus, row.index + 1), children: _jsx(FaPlus, {}) }), !record?.name && (_jsx(Button.Danger, { fill: "outline", onClick: () => onDelete(nucleus, row.index), children: _jsx(FaTimes, {}) }))] }));
            },
        },
    ], [datalist, mapOnChangeValue, mapValue, nucleus, onAdd, onDelete]);
    return (_jsx(ReactTable, { data: nucleiPreferences.nuclei[nucleus].columns, columns: COLUMNS }));
}
